import { hideLoader, showLoader } from "@/helpers/loader";
import { translate } from "@/locale/translate";
import { sendForm as mailchimp } from "./providers/mailchimp";
import { sendOrganizationForm as optima } from "./providers/optima";
import { assertEmptyFields } from "@/helpers/assertEmptyFields";
import { showNotification } from "@/helpers/notification";

import type { Fieldset } from "@/static/types";

export const submitCompanyForm = (form: HTMLFormElement) => {
  const lang = form.lang || "ru";
  const id = form.getAttribute("id");
  const toggleFormState = async (fieldset: Fieldset<HTMLInputElement>["company"]) => {
    if (!form) return;
    showLoader(form);
    try {
      const timeout = setTimeout(
        () => showNotification("Загрузка может занять некоторое время, пожалуйста, подождите"),
        5000,
      );
      await mailchimp(new FormData(form));
      const optimRes = await optima({
        name: fieldset.companyName.value,
        email: fieldset.email.value,
        phone: fieldset.phone.value,
        bik: fieldset.bik.value,
        bin: fieldset.bin.value,
        ibankName: fieldset.bankName.value,
        iban: fieldset.iban.value,
        ibankEmail: fieldset.bankEmail.value,
      });
      if (optimRes.status === 200) {
        const formData = new FormData(form);
        formData.append("MERGE11", "Yes");
        await mailchimp(formData);
      }
      clearTimeout(timeout);
      // hide feedback form and show success message
      const successMessageElement = document.querySelector(
        `div[data-modal-success-message="${id}"]`,
      );
      form?.classList.add("!hidden");
      form.parentElement?.classList.add("h-[95%]");
      successMessageElement?.classList.add("!flex");
    } catch (err) {
      console.log("Error when sending company form:", err);
    } finally {
      hideLoader(form);
    }
  };

  // text fields from DOM
  const fieldset: Fieldset<HTMLInputElement>["company"] = {
    // company
    companyName: document.getElementById("MERGE3-" + id) as HTMLInputElement,
    phone: document.getElementById("MERGE2-" + id) as HTMLInputElement,
    bin: document.getElementById("MERGE7-" + id) as HTMLInputElement,
    email: document.getElementById("MERGE0-" + id) as HTMLInputElement,

    // bank
    bankName: document.getElementById("MERGE6-" + id) as HTMLInputElement,
    iban: document.getElementById("MERGE8-" + id) as HTMLInputElement,
    bik: document.getElementById("MERGE9-" + id) as HTMLInputElement,
    bankEmail: document.getElementById("MERGE10-" + id) as HTMLInputElement,
  };
  const errors: Fieldset<string>["company"] = {
    // company
    companyName: "",
    phone: "",
    bin: "",
    email: "",

    // bank
    bankName: "",
    iban: "",
    bik: "",
    bankEmail: "",
  };
  // test all fields should be non-empty
  assertEmptyFields("company", fieldset, errors, lang);

  // test emails
  // regex to test an email
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;

  if (fieldset.email.value && !emailRegex.test(fieldset.email.value))
    errors.email = translate("Некорректный адрес email", lang);

  if (fieldset.bankEmail.value && !emailRegex.test(fieldset.bankEmail.value))
    errors.bankEmail = translate("Некорректный адрес email", lang);

  for (const el in errors) {
    const key = el as keyof typeof fieldset;
    if (fieldset[key]?.nextElementSibling?.tagName.toLowerCase() === "span")
      fieldset[key]!.nextElementSibling!.innerHTML = errors[key];
  }
  if (!Object.values(errors).some((el) => el)) {
    toggleFormState(fieldset);
  }
};
